"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license.
//
// MIT License:
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED ""AS IS"", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
// LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
// OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationActions;
(function (AuthenticationActions) {
    AuthenticationActions["Initializing"] = "AAD_INITIALIZING";
    AuthenticationActions["Initialized"] = "AAD_INITIALIZED";
    AuthenticationActions["LoginSuccess"] = "AAD_LOGIN_SUCCESS";
    AuthenticationActions["LoginFailed"] = "AAD_LOGIN_FAILED";
    AuthenticationActions["LoginError"] = "AAD_LOGIN_ERROR";
    AuthenticationActions["ClearError"] = "AAD_CLEAR_ERROR";
    AuthenticationActions["LogoutSuccess"] = "AAD_LOGOUT_SUCCESS";
    AuthenticationActions["AcquiredIdTokenSuccess"] = "AAD_ACQUIRED_ID_TOKEN_SUCCESS";
    AuthenticationActions["AcquiredIdTokenError"] = "AAD_ACQUIRED_ID_TOKEN_ERROR";
    AuthenticationActions["AcquiredAccessTokenSuccess"] = "AAD_ACQUIRED_ACCESS_TOKEN_SUCCESS";
    AuthenticationActions["AcquiredAccessTokenError"] = "AAD_ACQUIRED_ACCESS_TOKEN_ERROR";
    AuthenticationActions["AuthenticatedStateChanged"] = "AAD_AUTHENTICATED_STATE_CHANGED";
})(AuthenticationActions = exports.AuthenticationActions || (exports.AuthenticationActions = {}));
var AuthenticationActionCreators = /** @class */ (function () {
    function AuthenticationActionCreators() {
    }
    AuthenticationActionCreators.initializing = function () { return ({
        type: AuthenticationActions.Initializing,
    }); };
    AuthenticationActionCreators.initialized = function () { return ({
        type: AuthenticationActions.Initialized,
    }); };
    AuthenticationActionCreators.loginSuccessful = function (data) { return ({
        payload: data,
        type: AuthenticationActions.LoginSuccess,
    }); };
    AuthenticationActionCreators.loginFailed = function () { return ({
        type: AuthenticationActions.LoginFailed,
    }); };
    AuthenticationActionCreators.loginError = function (error) { return ({
        payload: error,
        type: AuthenticationActions.LoginError,
    }); };
    AuthenticationActionCreators.clearError = function () { return ({
        type: AuthenticationActions.ClearError,
    }); };
    AuthenticationActionCreators.logoutSuccessful = function () { return ({
        type: AuthenticationActions.LogoutSuccess,
    }); };
    AuthenticationActionCreators.acquireIdTokenSuccess = function (token) { return ({
        payload: token,
        type: AuthenticationActions.AcquiredIdTokenSuccess,
    }); };
    AuthenticationActionCreators.acquireIdTokenError = function (error) { return ({
        payload: error,
        type: AuthenticationActions.AcquiredIdTokenError,
    }); };
    AuthenticationActionCreators.acquireAccessTokenSuccess = function (token) { return ({
        payload: token,
        type: AuthenticationActions.AcquiredAccessTokenSuccess,
    }); };
    AuthenticationActionCreators.acquireAccessTokenError = function (error) { return ({
        payload: error,
        type: AuthenticationActions.AcquiredAccessTokenError,
    }); };
    AuthenticationActionCreators.authenticatedStateChanged = function (state) { return ({
        payload: state,
        type: AuthenticationActions.AuthenticatedStateChanged,
    }); };
    return AuthenticationActionCreators;
}());
exports.AuthenticationActionCreators = AuthenticationActionCreators;
//# sourceMappingURL=actions.js.map